import React from 'react';
import Breadcrumb from '../../components/Breadcrumb';
import About from './AboutArea';
import FunFact from './FunFactArea';
import Service from './ServiceArea';
import Work from './WorkArea';
import Testimonial from './TestimonialArea';
import Newsletter from '../../components/Newsletter';
import Team from './TeamArea';
import ChooseAre from '../home-5/ChooseArea';
import CountFunc from '../home-5/FunfactArea';
import ServiceArea from '../home-5/ServiceArea';
import TestimonialArea from '../home-5/TestimonialArea';
const AboutMain = () => {
  return (
    <main>
      <Breadcrumb title="About us" />
      <About />
      <ChooseAre />
      <CountFunc />
      {/* <FunFact /> */}
      <ServiceArea />
      {/* <Work /> */}
      <TestimonialArea />
      {/* <Newsletter /> */}
      <Team />
    </main>
  );
};


export default AboutMain;
